import { render, staticRenderFns } from "./ApprovalOfTheProposal.vue?vue&type=template&id=f99b9540&"
import script from "./ApprovalOfTheProposal.vue?vue&type=script&lang=js&"
export * from "./ApprovalOfTheProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports